import './Profile.css';

import { IonCol, IonContent, IonGrid, IonIcon, IonItem, IonPage, IonLabel, IonListHeader, IonRow, IonHeader, IonToolbar, IonButtons, IonText, useIonAlert, IonNote, IonSelect, IonSelectOption, IonToggle, ToggleCustomEvent, IonButton, IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle, SelectCustomEvent, IonFooter } from '@ionic/react';

import { cashOutline, closeOutline, colorPaletteOutline, documentOutline, documentTextOutline, languageOutline, lockClosedOutline, logoBitcoin, logoFacebook, logoTwitter, notificationsOutline, personOutline, fingerPrint } from 'ionicons/icons';
import { useAppSelector, useAppDispatch } from '../../services/redux/hook';

import { useUpdateUserDefaultCurrencyMutation, useUpdateUserDefaultLanguageMutation } from "../../services/api/ebioro/ebioro";
import ProfileDetailsPage from './profile-details/ProfileDetails';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import Avatar from 'react-avatar';
import { Browser } from '@capacitor/browser';
import { Capacitor } from '@capacitor/core';
import packageInfo from '../../../package.json';
import BiometricSecurity from '../../services/security/biometricSecurity';
import { setLanguage } from '../../services/redux/slices/language/language';
import { closeModal } from "../../services/redux/slices/opened_navigation_modal/opened_root_modal";
import useDarkMode from '../../hooks/useDarkMode';
import useCryptoMode from '../../hooks/useCryptoMode';
import { Provider } from 'react-redux';
import { store } from '../../services/redux/store';
import GeneratePdf from '../pdf/GeneratePdf';
import { useDeviceStorage } from '../../services/device_storage/useDeviceStorage';

const termsURL = import.meta.env.VITE_EBIORO_TC_URL;
const privacyURL = import.meta.env.VITE_EBIORO_PRIVACY_URL;
const ebioroTwitterUrl = import.meta.env.VITE_SOCIAL_TWITTER;
const ebioroFacebookUrl = import.meta.env.VITE_SOCIAL_FACEBOOK;


const Page: React.FC = () => {


    const nav = document.querySelector("ion-nav");
    const { darkMode, toggleDarkMode } = useDarkMode();
    const { cryptoMode, toggleModeHandler } = useCryptoMode();

    const { t, i18n } = useTranslation();
    const dispatch = useAppDispatch();
    const userInfo = useAppSelector((state) => state.user);
    const pin: string = useAppSelector((state) => state.pin);
    const [presentAlert] = useIonAlert();

    const [triggerUserLocaleUpdate] = useUpdateUserDefaultLanguageMutation();
    const [triggerCurrencyUpdate] = useUpdateUserDefaultCurrencyMutation();

    const selectedLanguage = useAppSelector((state: any) => state.language);


    const [seletectedCurrency, setSelectedCurrency] = useState(userInfo.currency_code);

    const walletInfo = useAppSelector((state) => state.walletInfo);

    // biometric state
    const [biometricAvailable, setBiometricAvailable] = useState(false);
    const [biometricEnabled, setBiometricEnabled] = useState(false);

    // local storage helpers for biometric flag
    const { get: getStorage, set: setStorage } = useDeviceStorage();
    const BIOMETRIC_FLAG_KEY = 'biometric_enabled';

    const close = () => {

        dispatch(closeModal());

    }

    const shortenAccountId = (fullStr: string, length?: number) => {

        let strLen = 18;
        if (length) {
            strLen = length
        }
        const separator = '...';

        if (fullStr.length <= strLen) return fullStr;

        const sepLen = separator.length;
        const charsToShow = strLen - sepLen;
        const frontChars = Math.ceil(charsToShow / 2);
        const backChars = Math.floor(charsToShow / 2);

        return fullStr.substr(0, frontChars) +
            separator +
            fullStr.substr(fullStr.length - backChars);
    }

    const goToProfileDetails = () => {
        nav?.push(() => <ProfileDetailsPage />)
    }


    const goToTerms = async () => {
        await Browser.open({ url: `${termsURL}` });
    }

    const followUsTwitter = async () => {

        await Browser.open({ url: `${ebioroTwitterUrl}` })
    }


    const likeUsOnFacebook = async () => {

        await Browser.open({ url: `${ebioroFacebookUrl}` })
    }


    const goToPrivacyPolicy = async () => {
        await Browser.open({ url: `${privacyURL}` });
    }


    const updateAppLanguage = async (value: any) => {

        try {
            dispatch(setLanguage(value));
            await i18n.changeLanguage(value);
            await triggerUserLocaleUpdate({ id: userInfo.id, locale: value }).unwrap();
        } catch (error) {
            console.error("Error updating language:", error);

        }


    }


    const updateCurrency = async (value: any) => {

        setSelectedCurrency(value)
        await triggerCurrencyUpdate({ id: userInfo.id, currency_code: value })

    }

    const presentErrorAlert = (error: string, title?: string) => {
        presentAlert({
            header: title ? title : "Error",
            message: `${error}`,
            buttons: [
                {
                    text: "Close",
                    role: "cancel",
                },
            ],
        });
    };

    // Monitor language changes
    useEffect(() => {
        console.log("selectedLanguage changed to:", selectedLanguage);
        console.log("i18n current language:", i18n.language);
    }, [selectedLanguage]);

    useEffect(() => {
        const initBiometric = async () => {
            try {
                if (Capacitor.getPlatform() === 'web') {
                    setBiometricAvailable(false);
                    setBiometricEnabled(false);
                    return;
                }
                const biometricSecurity = BiometricSecurity.getInstance();
                const avail = await biometricSecurity.isBiometricAvailable();
                setBiometricAvailable(!!avail.isAvailable);
                if (avail.isAvailable) {
                    // Read flag from local storage
                    const storedFlag = await getStorage(BIOMETRIC_FLAG_KEY);
                    const flagEnabled = storedFlag === 'true';

                    // Check credentials and reconcile with flag
                    const creds = await biometricSecurity.getCredentials('wallet_pin');
                    const credsEnabled = creds.success && !!creds.password;

                    await setStorage(BIOMETRIC_FLAG_KEY, credsEnabled ? 'true' : 'false');
                    setBiometricEnabled(credsEnabled);
                }
            } catch (e) {
                setBiometricAvailable(false);
                setBiometricEnabled(false);
            }
        };
        initBiometric();
    }, []);

    const toggleBiometric = async (checked: boolean) => {
        try {
            const biometricSecurity = BiometricSecurity.getInstance();
            if (checked) {
                if (!biometricAvailable) {
                    presentErrorAlert(String(t('biometric.enable')) + ': not available on this device');
                    return;
                }
                if (!pin || pin === '') {
                    presentErrorAlert(t('biometric.pinNotSet'));
                    return;
                }
                await biometricSecurity.verifyIdentity({
                    title: t('biometric.auth.TITLE') ?? "",
                    subtitle: t('biometric.auth.SUBTITLE') ?? "",
                    description: t('biometric.auth.DESCRIPTION') ?? ""
                });
                const res = await biometricSecurity.storeCredentials('wallet_pin', 'user', pin);
                if (res.success) {
                    setBiometricEnabled(true);
                    await setStorage(BIOMETRIC_FLAG_KEY, 'true');
                } else {
                    presentErrorAlert(res.error ?? 'Failed to enable biometric');
                }
            } else {
                const res = await biometricSecurity.deleteCredentials('wallet_pin');
                if (res.success) {
                    setBiometricEnabled(false);
                    await setStorage(BIOMETRIC_FLAG_KEY, 'false');
                } else {
                    presentErrorAlert(res.error ?? 'Failed to disable biometric');
                }
            }
        } catch (error: any) {
            presentErrorAlert(error?.message ?? 'Biometric operation failed');
        }
    };


    return (
        <IonPage >
            <IonHeader className="ion-no-border">
                <IonToolbar style={{ marginTop: "0%" }}>
                    <IonButtons slot='start'>
                        <IonButton onClick={() => { close() }} color='primary'>
                            <IonIcon slot="icon-only" icon={closeOutline} />
                        </IonButton>

                    </IonButtons>
                </IonToolbar>
                <IonToolbar style={{ marginTop: "0%" }}>
                    <IonGrid>
                        <IonRow className="ion-text-right ion-justify-content-center">
                            <IonCol size="4">
                                <Avatar
                                    name={`${userInfo?.first_name} ${userInfo?.last_name}`}
                                    size="50" round={true}
                                    email={userInfo?.email}
                                />
                            </IonCol>
                            <IonCol className='ion-text-left'>
                                <h5>
                                    {userInfo?.first_name ? `${userInfo.first_name} ${userInfo.last_name}` : shortenAccountId(walletInfo.account_key as string)}
                                </h5>

                            </IonCol>
                        </IonRow>
                        {/* <IonRow className={`ion-no-margin ion-text-center ion-justify-content-center`}>
                            <IonCol size="12">
                                <h5>
                                    {userInfo?.first_name ? `${userInfo.first_name} ${userInfo.last_name}` : shortenAccountId(walletInfo.account_key as string)}
                                </h5>
                            </IonCol>
                        </IonRow> */}
                        <IonRow className={`ion-no-margin ion-text-center ion-justify-content-center`}>
                            <IonCol size="12">
                                <IonText color='primary'>
                                    <h5>
                                        {userInfo?.paymentId}
                                    </h5>
                                </IonText>

                            </IonCol>
                        </IonRow>

                    </IonGrid>
                </IonToolbar>
            </IonHeader>

            <IonContent  className="ion-padding" scrollY={true}>

                <IonCard>
                    <IonCardHeader>
                        <IonCardSubtitle className='ion-text-start'

                        >
                            {t('profile.page.personal.HEADER')}
                        </IonCardSubtitle>
                    </IonCardHeader>
                    <IonCardContent>

                        <IonItem lines='none' detail={true} onClick={() => { goToProfileDetails() }}>
                            <IonIcon icon={personOutline} slot='start' />
                            <IonLabel>{t('profile.page.personal.profile.LABEL')}</IonLabel>
                        </IonItem>

                        <IonItem lines='none' onClick={() => { { } }}>
                            <IonIcon icon={cashOutline} slot='start' />
                            <IonSelect label={t('profile.page.personal.currency.LABEL') as string} slot='end' interface="popover" value={seletectedCurrency} onIonChange={(e: any) => updateCurrency(e.detail.value)} >
                                <IonSelectOption value="CAD">CAD</IonSelectOption>
                                <IonSelectOption value="EUR">EUR</IonSelectOption>
                                <IonSelectOption value="USD">USD</IonSelectOption>
                                <IonSelectOption value="GBP">GBP</IonSelectOption>
                            </IonSelect>

                        </IonItem>

                        <IonItem lines='none' onClick={() => { { } }}>
                            <IonIcon icon={languageOutline} slot='start' />

                            <IonSelect label={t('profile.page.personal.language.LABEL') as string} slot='end' interface="popover" value={selectedLanguage} onIonChange={(e: SelectCustomEvent) => updateAppLanguage(e.detail.value)} >
                                <IonSelectOption value="en">English</IonSelectOption>
                                <IonSelectOption value="es">Español</IonSelectOption>
                            </IonSelect>

                        </IonItem>

                        {/* <IonItem lines='none'>
                            <IonIcon icon={colorPaletteOutline} slot='start' />
                            <IonToggle
                                checked={darkMode}
                                onIonChange={toggleDarkMode}>
                                {t('profile.page.personal.theme.LABEL')}
                            </IonToggle>
                        </IonItem> */}

                        {/* Biometric toggle moved from AccountsPage */}
                        <IonItem lines='none'>
                            <IonIcon icon={fingerPrint} slot='start' />
                            <IonToggle
                                checked={biometricEnabled}
                                disabled={!biometricAvailable}
                                onIonChange={(e) => toggleBiometric(e.detail.checked)}
                            >
                                {t('biometric.option')}
                            </IonToggle>
                        </IonItem>



                    </IonCardContent>
                </IonCard>

                <IonCard>
                    <IonCardHeader>
                        <IonCardSubtitle
                            className='ion-text-start'

                        >
                            {t('profile.page.crypto.HEADER')}
                        </IonCardSubtitle>
                    </IonCardHeader>
                    <IonCardContent>

                        <IonItem lines='none'>
                            <IonIcon icon={logoBitcoin} slot='start' />
                            <IonToggle
                                checked={cryptoMode}
                                onIonChange={toggleModeHandler}
                            >
                                {t('profile.page.crypto.LABEL')}
                            </IonToggle>
                        </IonItem>

                    </IonCardContent>
                </IonCard>

                <IonCard>
                    <IonCardHeader>
                        <IonCardSubtitle
                            className='ion-text-start' >{t('profile.page.about.HEADER')}</IonCardSubtitle>
                    </IonCardHeader>
                    <IonCardContent>

                        <IonItem lines='none' detail={true} onClick={() => followUsTwitter()}>
                            <IonIcon icon={logoTwitter} slot='start' />
                            <IonLabel>{t('profile.page.Twitter.LABEL')}</IonLabel>
                        </IonItem>

                        <IonItem lines='none' detail={true} onClick={() => likeUsOnFacebook()}>
                            <IonIcon icon={logoFacebook} slot='start' />
                            <IonLabel>{t('profile.page.Facebook.LABEL')}</IonLabel>
                        </IonItem>

                    </IonCardContent>
                </IonCard>


                <IonCard>
                    <IonCardHeader >
                        <IonCardSubtitle
                            className='ion-text-start'>
                            {t('profile.page.legal.HEADER')}
                        </IonCardSubtitle>


                    </IonCardHeader>
                    <IonCardContent>

                        <IonItem lines='none' detail={true} onClick={() => (goToTerms())}>
                            <IonIcon icon={documentOutline} slot='start' />
                            <IonLabel>{t('profile.page.Terms.LABEL')}</IonLabel>
                        </IonItem>

                        <IonItem lines='none' detail={true} onClick={() => (goToPrivacyPolicy())}>
                            <IonIcon icon={lockClosedOutline} slot='start' />
                            <IonLabel>{t('profile.page.Privacy.LABEL')}</IonLabel>
                        </IonItem>



                    </IonCardContent>
                </IonCard>



            </IonContent>
            <IonFooter className="ion-no-border">

                <IonToolbar>
                    <div className='walletVersion'>
                        <IonLabel className='ion-text-center'> <IonNote>{t('profile.page.WALLET-VERSION')} {packageInfo.version}</IonNote></IonLabel>
                    </div>
                </IonToolbar>
            </IonFooter>
        </IonPage>
    );
};

const ProfilePage: React.FC = () => (
    <Provider store={store}>
        <Page />
    </Provider>
);

export default ProfilePage;
